import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import { Container, LoginContainer, FormContainer } from "./login.styled";
import {
    FlexBox,
    Form,
    FormItem,
    ButtonWrap,
    Button,
} from "static/coreStyles/global.styled";
import { userLogin } from "actions/login";
import { validateEmail } from "utility/helperFunctions";

const Login = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [emailError, setEmailError] = useState("");
    const [passwordError, setPasswordError] = useState("");

    const handleInputChange = (key, value) => {
        const trimmedValue = value[0] !== " " ? value : value.trim();

        if (key === "email") {
            setEmail(trimmedValue);
            if (trimmedValue !== "" && validateEmail(trimmedValue)) {
                setEmailError("");
            }
        } else if (key === "password") {
            setPassword(trimmedValue);
            if (trimmedValue !== "") {
                setPasswordError("");
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        let hasError = false;
        const isValidatedEmail = validateEmail(email);

        if (email === "") {
            setEmailError("Enter email id.");
            hasError = true;
        } else if (!isValidatedEmail) {
            setEmailError("Enter valid email.");
            hasError = true;
        } else {
            setEmailError("");
        }

        if (password === "") {
            setPasswordError("Password cannot be empty.");
            hasError = true;
        } else {
            setPasswordError("");
        }

        if (!hasError) {
            const response = await dispatch(userLogin({ email, password }));
            if (response) {
                navigate("/");
            }
        }
    };

    return (
        <Container>
            <LoginContainer>
                <img alt="cover-img" src={require("static/images/cover-img.jpg")} />
                <FormContainer>
                    <img
                        className="logo"
                        alt="login-logo"
                        src={require("static/images/login-logo.svg")}
                    />
                    <FlexBox start={1} column className="welcome-text">
                        <h2>Hello, Welcome back</h2>
                        <span>Please login to your account</span>
                    </FlexBox>
                    <Form>
                        <FormItem>
                            <label>Email ID</label>
                            <input
                                type="text"
                                placeholder="Enter email id"
                                onChange={(e) => handleInputChange("email", e.target.value)}
                            />
                            {emailError && (
                                <span className="error-msg">{emailError}</span>
                            )}
                        </FormItem>
                        <FormItem>
                            <label>Password</label>
                            <input
                                type="password"
                                placeholder="Enter password"
                                onChange={(e) => handleInputChange("password", e.target.value)}
                            />
                            {passwordError && (
                                <span className="error-msg">{passwordError}</span>
                            )}
                        </FormItem>
                        <ButtonWrap className="login-btn-wrap">
                            <Button primary onClick={handleSubmit}>Login</Button>
                        </ButtonWrap>
                    </Form>
                </FormContainer>
            </LoginContainer>
        </Container>
    );
};

export default Login;
